import { Observable } from 'rxjs';
import { FinalIncentiveProgramModel } from '../domain/new-incentive-program.model';

export abstract class NewIncentiveProgramRepository {
  abstract getNewIncentiveProgramDetails(): Observable<FinalIncentiveProgramModel>;
}
